import { render } from "./StepActions.vue?vue&type=template&id=5caac156&scoped=true&ts=true"
import script from "./StepActions.vue?vue&type=script&lang=ts"
export * from "./StepActions.vue?vue&type=script&lang=ts"

import "./StepActions.vue?vue&type=style&index=0&id=5caac156&scoped=true&lang=scss"

import exportComponent from "/tmpfs/builds/maltcommunity/malt/apps/malt/node_modules/.pnpm/vue-loader@17.0.1_p6ywf2fz4v3oextcdrklqlunue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5caac156"]])

export default __exports__